/* eslint-disable */
export const extractAuthToken = (getState: any): string =>
  getState().auth.token;
